module.exports = "https://cdn2-fs.clearscore.com/flux/images/47bb2bb2c2d2100e47033511974f8717.jpg";